import citiesService from '@/services/cities.service'

export default {
  namespaced: true,
  state: {
    cities: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_CITIES(state, cities) {
      state.cities = cities
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_CITY(state, city) {
      state.cities.push(city)
    },
    UPDATE_CITY(state, updatedCity) {
      const index = state.cities.findIndex(c => c.id === updatedCity.id)
      if (index !== -1) {
        state.cities.splice(index, 1, updatedCity)
      }
    },
    REMOVE_CITY(state, id) {
      state.cities = state.cities.filter(c => c.id !== id)
    }
  },
  actions: {
    async fetchCities({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await citiesService.getAll()
        // Handle paginated response - data is nested in response.data.data
        const cities = response.data?.data || response.data || []
        commit('SET_CITIES', cities)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createCity({ commit }, cityData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await citiesService.create(cityData)
        if (response.success) {
          commit('ADD_CITY', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateCity({ commit }, { id, cityData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await citiesService.update(id, cityData)
        if (response.success) {
          commit('UPDATE_CITY', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteCity({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await citiesService.delete(id)
        if (response.success) {
          commit('REMOVE_CITY', id)
          return { success: true }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    allCities: state => state.cities,
    activeCities: state => state.cities.filter(c => c.active),
    citiesByCountry: state => countryId => state.cities.filter(c => c.country_id === countryId),
    isLoading: state => state.loading
  }
}

